export default {
  supplier: {
    searchPlaceholder: '供应商编号/供应商名称',
    purchaseUnitName: '采购中心',
    supplierNo: '供应商编码',
    supplierName: '供应商名称',
    creditCode: '统一社会信用代码',
    addressStr: '地址',
    master: '负责人',
    phone: '联系电话'
  },
  setting: {
    searchPlaceholder: '供应商编号/供应商名称',
    purchaseNo: '采购中心编码',
    purchaseName: '采购中心名称',
    supplierNo: '供应商编码',
    supplierName: '供应商名称',
    creditCode: '统一社会信用代码',
    addressStr: '地址',
    master: '负责人',
    phone: '联系电话',
    purchaseUnitId: '采购中心',
    officeType: '机构别',
    maintain: '关系维护',
    relieve: '关系解除',
    throw: '抛转ERP',
    relieveMsg: '是否确定解除？'
  },
  company: {
    name: '企业名称',
    officeNo: '机构编码',
    officeAbbreviation: '企业简称',
    officeType: '机构别'
  },
  purchaser: {
    searchPlaceholder: '客户编号/客户名称',
    purchaseNo: '客户编码',
    purchaseName: '客户名称',
    creditCode: '统一社会信用代码',
    addressStr: '地址',
    master: '负责人',
    phone: '联系电话'
  }
}
